import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isIOS } from '@uifabric/utilities';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

export const isMeControlEnabled = () =>
    isMiniHostAppFeatureEnabled('miniMeControl') && (isIOS() ? isConsumer() : true);
